// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Images/toggle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Images/genaiofferrings-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Images/bigdataofferrings-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./Images/plusiconv2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Images/minusiconv3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-body-tertiary {
    /* background: linear-gradient(114.88deg, #06000C -2.45%, #06000C 58.38%, #06000C 101.84%); */
    /* background: linear-gradient(267.03deg, #00F0FF 4.01%, #5200FF 57.55%, #FF2DF7 114.97%); */
    /* background: linear-gradient(114.88deg, rgba(6, 0, 12, 1) -2.45%, rgba(6, 0, 12, 1) 58.38%, rgba(6, 0, 12, 1) 101.84%); */
    /* background: linear-gradient(114.88deg, #06000C -2.45%, #06000C 58.38%, #06000C 101.84%); */

    /* background: linear-gradient(267.03deg, #00F0FF 4.01%, #5200FF 57.55%, #FF2DF7 114.97%); */
    /* background-color: rgba(6, 0, 12, 1); */

    /* background: #06000C !important; */

    /* --bs-tertiary-bg-rgb:#06000C;  */
    /* --bs-bg-opacity: 0; */
    border-bottom: 1px solid #5E2C8C;
    /* --bs-body-bg:#06000C; */
    /* Group 33092 */
    /* Ellipse 874 */

    /* position: absolute;
    width: 1779px;
    height: 516px;
    left: 57px;
    top: -206px; */

    /* background: #11011F; */
    /* filter: blur(100px); */

    /* overflow: visible; */

    box-shadow: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    box-shadow: #B86BEB;
    background: linear-gradient(114.88deg, rgba(0, 10, 31, 1) -2.45%, rgba(17, 1, 31, 1) 58.38%, rgba(0, 10, 31, 1) 101.84%);
    /* background: linear-gradient(267.03deg, #00F0FF 4.01%, #00F0FF 57.55%, #00F0FF 114.97%); */
    /* background: linear-gradient(114.88deg, #00F0FF -2.45%, #5200FF 58.38%, #FF2DF7 101.84%); */
    /* filter: blur(385.133px); */

}

.arrow-button {
    /* width: 30px;
    height: 20px; */
    top: 52.57px;
    left: 1303.53px;
    padding: 3.29px 2.63px 3.29px 2.63px;
    gap: 0px;
    opacity: 1;

}

.company {
    /* background:  rgba(6, 0, 12, 1); */
    background: rgba(36, 36, 36, 0.2);
    display: flex;
    flex-direction: row;
}

/* 
.company-icon {
    width: Fill (223px)px;
    height: Hug (72px)px;
    padding: 16px 30px 16px 0px;
    gap: 2px;
    opacity: 0px;

} */

.header {
    height: 14vh;
}

.outlineButton {
    border: 0.85px solid red;
    border-color: #0C0611;
    border-image-source: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%);

}

.btn:hover {
    --bs-btn-hover-color: white;
    --bs-btn-hover-bg: transparent;
}

.btn-primary {
    --bs-btn-color: white;
    --bs-btn-bg: transparent;
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    font-size: 17px;
}

.btn {
    --bs-border-radius: 20px;
    --bs-btn-border-radius: 22px;
    --bs-btn-bg: transparent;
}

.font-header {
    font-family: "Roboto", sans-serif;
    font-weight: 800;
    /* font-size: 55px; */
    text-align: left;
}

.font-caption {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    /* font-size: 15px; */
    text-align: left;
    color: rgba(255, 255, 255, 0.7);
    /* We leverage Big Data and Hadoop technologies to handle the three key areas of data: Variety, Volume, and Velocity. By employing distributed storage and computation, we deliver efficient solutions, including enterprise data lakes and real-time streaming applications */

    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

}

.carousel-indicators [data-bs-target] {
    display: none !important;
}

/* .dropdown{
    color: white;
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    font-size: 17px;
} */
.navbar-collapse.collapse.show {
    /* text-align: left;    
    display: flex;
    justify-content: center; 
    align-items: center;  */
    /* padding: 10px;  */

}



.navbar-toggler-icon {
    --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
}

@media (min-width: 1400px) {
    .brandspacing {
        margin-left: 100px;
    }

    /* .companyreiconsponsive {
        width: 200vw;
        height: 10vh;
        gap: 30px;
        opacity: 0px;
        padding: 16px, 30px, 16px, 30px;
    } */
}

/* @media (min-width: 1200px) {
    .companyreiconsponsive {
        width: 16vw;
        height: 10vh;
        gap: 10px;
        opacity: 0px;
        padding: 16px, 30px, 16px, 30px;
    }
}
@media (min-width: 992px) { 
.companyreiconsponsive {
    width: 5vw;
    height: 10vh;
    gap: 0px;
    opacity: 0px;
    padding: 16px, 30px, 16px, 30px;
}
} */

/* @media (min-width: 768px) { 
    .companyreiconsponsive {
        width: 16vw;
        height: 10vh;
        gap: 0px;
        opacity: 0px;
        padding: 16px, 30px, 16px, 30px;
    } } */

@media (min-width: 576px) {
    .companyreiconsponsive {
        width: 16vw;
        height: 13vh;
        gap: 0px;
        opacity: 0px;
        padding: 16px, 30px, 16px, 30px;
        justify-content: center;
        align-items: center;
    }
}

@media (max-width: 300px) {
    .companyreiconsponsive {
        width: 16vw;
        height: 13vh;
        gap: 0px;
        opacity: 0px;
        padding: 16px, 30px, 16px, 30px;
        justify-content: center;
        align-items: center;
    }

    .dropdown-menu {
        --bs-body-bg: transparent !important;
        --bs-dropdown-padding-x: 0rem !important;
        box-shadow: none !important;
        --bs-border-width: 0px !important;

    }
}

/* @media (min-width: 576px) { ... }

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) { ... }

// Large devices (desktops, 992px and up)
@media (min-width: 992px) { ... }

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) { ... }

// Extra extra large devices (larger desktops, 1400px and up)
@media (min-width: 1400px) { ... } */

/* .company-icon {
    width: Fill (223px)px;
    height: Hug (72px)px;
    padding: 16px 30px 16px 0px;
    gap: 2px;
    opacity: 0px;

} */

@media (max-width: 992px) {
    .header {
        height: 18vh;

    }

    .navbar-collapse.collapse.show {
        z-index: 10;
        background: linear-gradient(114.88deg, rgba(0, 10, 31, 1) -2.45%, rgba(17, 1, 31, 1) 58.38%, rgba(0, 10, 31, 1) 101.84%);
        border-radius: 24.16px;
        padding: 1rem 0rem;
        border-radius: 10px;
        color: rgba(255, 255, 255, 1);
        border: 1px solid rgba(28, 31, 34, 1);

        box-sizing: border-box;

        transition: opacity 0.5s ease-in-out;
        box-shadow: 0px 44.3094px 103.389px rgba(125, 24, 188, 0.2);

    }

    .dropdown-menu {
        --bs-body-bg: transparent !important;
        --bs-dropdown-padding-x: 0rem !important;

    }

    .demo {
        width: 80%;
    }

}


/* .dropdown-menu {
    --bs-body-bg: rgba(23, 23, 23, 1);
    --bs-border-radius: 24.16px;
    --bs-border-color-translucent: rgba(28, 31, 34, 1);
    box-shadow: 0px 36.24px 84.57px 0px rgba(167, 174, 186, 0.16);
    --bs-border-width: 1.51px;
    color: rgba(255, 255, 255, 1);
    --bs-dropdown-padding-y: 1rem !important;
    --bs-dropdown-padding-x: 1rem !important;

}

.dropdown-item {
    --bs-dropdown-link-color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: 700;
    font-family: "Roboto", sans-serif;
    --bs-dropdown-item-padding-y: 0.50rem;
    --bs-dropdown-item-padding-x: 1rem;
    margin: 10px 0px;
}

.dropdown-item:focus,
.dropdown-item:hover {
    --bs-dropdown-link-hover-color: rgba(255, 255, 255, 1);
    --bs-dropdown-link-hover-bg: none;
    background: linear-gradient(270deg, rgba(23, 23, 23, 0.5) 0.26%, rgba(125, 24, 188, 0.5) 40.8%, rgba(23, 23, 23, 0.5) 102.25%) !important;
} */

.nav-link {
    line-height: 27.3px;
    color: white;
    --bs-nav-link-color: white;
    font-family: "Roboto", sans-serif;
    --bs-nav-link-font-weight: 700;
    --bs-nav-link-font-size: 17px;
}

.nav-link:hover {
    color: white;
    --bs-nav-link-hover-color: white;
}

.nav-link:focus {
    color: white;
    --bs-nav-link-focus-color: white;
}

.navbar-expand-xxl .navbar-nav .nav-link {
    --bs-navbar-nav-link-padding-x: 25px;
    font-weight: 800;
}

.navbar-nav .nav-link.active,
.navbar-nav .nav-link.show {
    --bs-navbar-active-color: white;

}

/* .dropdown-button-no-caret, .dropdown-button-no-caret:focus{
    background-color: transparent;
    color: white;
    border: none;
}
.dropdown-button-no-caret:hover{
    background-color: white;
}

.dropdown-button-no-caret::after{
    display: none !important;
} */
/* We leverage Big Data and Hadoop technologies to handle the three key areas of data: Variety, Volume, and Velocity. By employing distributed storage and computation, we deliver efficient solutions, including enterprise data lakes and real-time streaming applications */



@media (min-width: 300px) {
    .CarouselHeader {
        width: 100%;
    }

    .carousel-caption {
        bottom: 0% !important;
        left: 10% !important;
    }

    .font-header {
        font-size: 13px;
    }

    .font-caption {
        line-height: 15px;
        width: 100% !important;
        /* margin-left: 2vw !important; */
    }
}

@media (min-width: 345px) {
    .CarouselHeader {
        width: 100%;
    }

    .carousel-caption {
        bottom: 0% !important;
        left: 10% !important;
    }

    .font-header {
        font-size: 17px;
    }

    .font-caption {
        line-height: 17px;
        width: 100% !important;
        /* margin-left: 2vw !important; */
    }
}

@media (min-width: 400px) {
    .CarouselHeader {
        width: 100%;
    }

    .carousel-caption {
        bottom: 1% !important;
        left: 10% !important;
    }

    .font-header {
        font-size: 20px;
    }

    .font-caption {
        line-height: 19px;
        width: 90% !important;
        /* margin-left: 2vw !important; */
    }
}

@media (min-width: 450px) {
    .CarouselHeader {
        width: 100%;
    }

    .carousel-caption {
        bottom: 1% !important;
        left: 10% !important;
    }

    .font-header {
        font-size: 25px;
    }

    .font-caption {
        line-height: 20px;
        width: 90% !important;
        /* margin-left: 2vw !important; */
    }
}

@media (min-width: 576px) {
    .CarouselHeader {
        width: 100%;
    }

    .carousel-caption {
        bottom: 5% !important;
        left: 10% !important;
    }

    .font-header {
        font-size: 30px;
    }

    .font-caption {
        line-height: 23px;
        width: 70% !important;
        /* margin-left: 2vw !important; */
    }
}

@media (min-width: 600px) {
    .CarouselHeader {
        width: 100%;
    }

    .carousel-caption {
        bottom: 10% !important;
        left: 10% !important;
    }

    .font-header {
        font-size: 35px;
    }

    .font-caption {
        line-height: 23px;
        width: 65% !important;
        /* margin-left: 2vw !important; */
    }
}

@media (min-width: 768px) {
    .CarouselHeader {
        width: 100%;
    }

    .carousel-caption {
        bottom: 13% !important;
        left: 10% !important;
    }

    .font-header {
        font-size: 45px;
    }

    .font-caption {
        line-height: 23px;
        width: 40% !important;
        /* margin-left: 2vw !important; */
    }
}

@media (min-width: 992px) {
    .CarouselHeader {
        width: 100%;
    }

    .carousel-caption {
        bottom: 30% !important;
        left: 10% !important;
    }

    .font-header {
        font-size: 55px;
    }

    .font-caption {
        line-height: 23px;
        width: 40% !important;
        /* margin-left: 2vw !important; */
    }
}

@media (min-width: 1200px) {
    .CarouselHeader {
        width: 70%;
    }

    .carousel-caption {
        bottom: 20% !important;
        left: 10% !important;
    }

    .font-header {
        font-size: 55px;
    }

    .font-caption {
        line-height: 23px;
        width: 40% !important;
        /* margin-left: 2vw !important; */
    }
}

@media (min-width: 1400px) {
    .CarouselHeader {
        width: 40%;
    }

    .carousel-caption {
        bottom: 20% !important;
        left: 8% !important;
    }

    .font-header {
        font-size: 55px;
    }

    .font-caption {
        line-height: 23px;
        width: 40% !important;
        /* margin-left: 2vw !important; */
    }
}


.carousel-control-next-icon,
.carousel-control-prev-icon {
    width: 0rem !important;
    height: 0rem !important;
}

.carousel-caption {
    /* position: absolute;
    right: 15%; */
    /* bottom: 50%;
    left: 5%; */
    /* color: #7D18BC; */
    /* left: 15%;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
    color: #fff;
    text-align: center; */
}

/* .carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
    margin-bottom: -5%;
    margin-top: -5%;
} */

.discover-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* width: 100px;
    height: 100px; */
    background: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%);
    ;
    /* Example background color */
    border-radius: 50%;
    /* Makes the div a circle */
    color: #ffffff;
    /* Text color */
    text-align: center;
    cursor: pointer;
    /* Optional: Cursor style */
}

.discover-icon {
    font-size: 24px;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 11px;
    color: rgba(255, 255, 255, 1);
}


.flexColumn {
    display: flex;
    flex-direction: row !important;
}

/* CustomNavbar.css */
.custom-dropdown .dropdown-toggle::after {
    /* content: url('./Images/dropdownarrow.svg');  */
    margin-left: 0.5em;
}

/* .dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: 0em solid !important;
    border-right: 0em solid transparent;
    border-bottom: 0;
    border-left: 0em solid transparent;
    content: url('./Images/dropdownarrow.svg'); 
} */

.navbar {
    margin-top: 0;
    padding-top: 0;
    /* --bs-navbar-toggler-icon-bg: url('./Images/dropdownarrow.svg'); */
}


.content {
    /* background: rgba(6, 0, 12, 1); */

    background: #08080A;


}

/* Section 1 */
/* 
position: absolute;
left: -5.41%;
right: -3.59%;
top: 47.58%;
bottom: 32.82%;

background: linear-gradient(180deg, #101019 0%, #101019 63.16%);
transform: matrix(1, 0.02, -0.02, 1, 0, 0); */



/* transition: opacity .15s ease; */
.underlinetext {
    position: relative;
    /* background-image: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%); */

    /* text-decoration-color: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%); */
    /* background: linear-gradient(#e66465, #9198e5); */
    /* background-image: linear-gradient(90deg,rgb(98,60,49)0,rgb(255,255,255) 100%); */
}

.underlinetext::before {
    content: "";
    position: absolute;
    top: 80%;
    width: 100%;
    left: 0;
    height: 5px;
    /* border-radius: 2px; */
    background: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%);
}

.content-services {
    /* color: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%); */
    color: rgba(255, 255, 255, 1);
    font-family: "Roboto", sans-serif;
    /* font-size: 50px; */
    font-weight: 100;
    line-height: 81.71px;
}

.gradient-text {
    background-image: linear-gradient(180deg, #B86BEB, #7D18BC);
    -webkit-background-clip: text;
    /* For Safari/Chrome */
    background-clip: text;
    /* Standard property */
    color: transparent;
    /* Hide the original text */
}


.sub-header {
    font-family: "Roboto", sans-serif;
    /* font-size: 18px;
    line-height: 35px; */
    font-weight: 300;
    letter-spacing: -0.006em;
    text-align: center;
    color: #E6E6E6;


}

.bg-layout {
    position: relative;
    overflow: visible;
    /* width: 828.66px;
height: 809.31px;
top: 974px;
left: 1007.27px;
gap: 0px;
border: 3.54px 0px 0px 0px; */
    opacity: 0.05px;
    /* background-position: right; */
    /* background-position: 50%; */
    /* transform: rotate(-45deg); */
    /* background-image: url('./Images/bg-imge.svg'); */


}

.bg-layout::before {

    content: "";
    position: absolute;
    bottom: 10vh;
    width: 100%;
    height: 38vh;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
    /* background-size: cover; */
    /* background-size: contain; */
    object-fit: cover;

}

@media(max-width: 567px) {
    .bg-layout::before {
        background-size: contain;
        top: -20vh;
    }

    .bigdatafferinglayout::before {
        background-size: contain;
        background-repeat: no-repeat;

    }

}

@media(max-width: 944px) {
    .bg-layout::before {
        background-size: contain;
        top: -19vh;
    }

    .bigdatafferinglayout::before {
        width: 40vw;
        height: 100%;
        background-size: contain;

        background-repeat: no-repeat;
    }

}

@media(min-width: 945px) {
    .bg-layout::before {
        background-size: cover;
        top: -25vh;
    }

    .bigdatafferinglayout::before {
        width: 40vw;
        height: 100%;
        background-size: cover;
    }
}

.oval-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    filter: blur(50px);
    /* left: -15vh; */
    z-index: -10;
    background: radial-gradient(ellipse at center, rgba(125, 24, 188, 0.3) 0%, transparent 80%);
}


.cloudofferinglayout {
    position: relative;
 }

.cloudofferinglayout::before {
    content: "";
    position: absolute;
    top: 0%;
    left: 0;
    background-position: top;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    /* background: url('./Images/cloudofferrings-bg.svg') no-repeat center center; */
    background-size: cover;
    /* width: 3722px;
    height: 909px; */
    /* top: 1902px;
    left: -332px; */
    gap: 0px;
    opacity: 0px;
    /* z-index: 2; */
    background: linear-gradient(180deg, #101019 0%, #101019 63.16%)
        /* Adjust size as needed */
        /* transform: translate(-50%, -50%) rotate(45deg);  */
        /* transform: rotate(25deg); */
        /* width: 830.33px;
    height: 880px; */
        /* top: 2031px; */
        /* left: -169.33px;
    gap: 0px;
    border: 1.46px 0px 0px 0px;
    opacity: 0.05px; */
}

.bigdatafferinglayout {
    position: relative;
    padding: 0px 10px;

}

.bigdatafferinglayout::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background-position: top;
    /* width: 40vw;
    height: 110vh; */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    /* background-repeat: repeat-x; */
    /* background-size: contain; */
}

.accordion-body {
    /* font-weight: 100; */
    /* font-size: 16px; */
    text-align: left;
    /* --bs-accordion-body-padding-y: 1.50rem;
    --bs-accordion-body-padding-x: 1.25rem */
}

.accordion-item {
    --bs-accordion-bg: transparent;
    --bs-accordion-color: rgba(249, 249, 249, 1);
    --bs-body-font-size: 18px;
    font-weight: 300;
    font-family: "Roboto", sans-serif;
    /* border-top: 1px solid #B86BEB; */


}

.accordion-item:first-of-type>.accordion-header .accordion-button {
    border: none;
}

.accordion-item .accordion-header .accordion-button {
    border-top: 1px solid #B86BEB;
    z-index: 10;
}

.accordian-item.collapsed {
    --bs-accordion-btn-bg: transparent;
    --bs-accordion-active-bg: transparent;
    /* border: 1px solid #B86BEB; */
}

.accordion-item:not(.collapsed) {
    --bs-accordion-active-bg: transparent;
    /* border-top: 1px solid #B86BEB; */
}

.accordion-button::after {
    --bs-accordion-btn-bg: transparent;
    --bs-accordion-active-bg: transparent;
}

.accordion-button.collapsed {
    --bs-accordion-color: #F9F9F9;
    --bs-accordion-btn-bg: transparent;
    --bs-accordion-active-bg: transparent;
}

.accordion-button:not(.collapsed)::after {
    --bs-accordion-btn-bg: transparent;
    --bs-accordion-active-bg: transparent;
}

.accordion-button:not(.collapsed) {
    --bs-accordion-active-bg: transparent;
    /* border-top: 1px solid #B86BEB; */
}

.accordion-button {
    /* font-size: 20px !important; */
    --bs-accordion-btn-bg: transparent;
    --bs-accordion-active-bg: transparent;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
}

.accordion-button.collapsed {
    --bs-accordion-btn-bg: transparent;
    --bs-accordion-active-bg: transparent;
    /* font-size: 20px !important; */
    font-family: "Roboto", sans-serif;
    /* font-weight: 500; */
    /* border-top: 1px solid #B86BEB; */
    --bs-accordion-btn-color: #F9F9F9;
}

.accordion-item:first-of-type {
    /* border-top: none; */
}

/* .first-item.accordion-button.collapsed {
    border: none;
} */


.button.accordion-button.collapsed {
    --bs-accordion-btn-bg: transparent;
    --bs-accordion-active-bg: transparent;
    /* font-size: 20px; */
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    --bs-accordion-btn-color: #F9F9F9;
}

.accordion-header {
    font-size: 20px;
    font-family: "Roboto", sans-serif;
    /* font-weight: 500; */
    color: #F9F9F9;
}

.accordion-button::after {
    --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_3___});

    --bs-border-color: none;
}

.accordion-button:not(.collapsed)::after {
    --bs-accordion-active-bg: transparent;
    --bs-accordion-bg: transparent;
    --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    --bs-accordion-btn-icon-transform: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

/* .accordion-button:not(.collapsed)::after {
    --bs-accordion-active-bg: transparent;
    --bs-accordion-bg: transparent;
    --bs-accordion-btn-active-icon: url(http://localhost:3000/static/media/minusicon.6d2fe56….svg);
    --bs-accordion-btn-icon-transform: url(http://localhost:3000/static/media/plusicon.4c797a6….svg);
} */

.accordion-button:focus {
    --bs-accordion-btn-focus-box-shadow: none;
}



.accordianimage {
    /* width: 561px;
    height: 437px; */
    /* width: 35vw;
    height: 60vh; */
    /* top: 5px;
    gap: 0px;
    opacity: 0px; */

}

.accordiancontent {
    /* width: 1251px; */
    height: 100%;
    /* margin-left: 94px; */
    /* justify-content: center; */

}

.accordion {
    --bs-border-color: none;
    --bs-primary-text-emphasis: #EEEEF0;
}

@media(min-width: 200px) and (max-width: 345px) {
    .accordion {
        width: 100%;
        margin-top: 15px;
    }

    .accordiancontent {
        justify-content: center;
        align-items: center;
    }

    .content-services {
        font-size: 30px;
    }

    .sub-header {
        font-size: 12px;
        line-height: 20px;
    }

    .center-button {
        height: 35px;
        width: 160px;
    }

    .buttoncontainer {
        margin-top: 5rem;
    }

    .imageoverlay {
        height: 30%;
        margin: 10px 20px 10px 3px;
        border-radius: 10px;
    }

    .button-center.btn.btn-primary {
        font-size: 12px;
    }

    .footer-msg {
        font-size: 13px;
        line-height: 25px;
    }

    .cloudofferinglayout {
        /* height: 150vh */
    }

    .BigDataOfferings {
        gap: 10px;
    }

    .rowgap {
        gap: 10px;
    }

    .discover-button {
        width: 100%;
        height: 100%;
        padding: 10px 2px;
    }

    .discover-icon {
        width: 10px;
    }

    .discover-text {
        margin-top: 5px;
        font-size: 7px;
    }

    .font-caption {
        font-size: 8px;
        /* letter-spacing: 0px; */
    }
}

@media(min-width: 345px) and (max-width: 567px) {
    .accordion {
        width: 100%;
        margin-top: 15px;
    }

    .accordiancontent {
        justify-content: center;
        align-items: center;
    }

    .content-services {
        font-size: 30px;
    }

    .sub-header {
        font-size: 12px;
        line-height: 20px;
    }

    .center-button {
        height: 35px;
        width: 160px;
    }

    .buttoncontainer {
        margin-top: 5rem;
    }

    .imageoverlay {
        height: 32%;
        margin: 10px 20px 10px 3px;
        border-radius: 10px;
    }

    .button-center.btn.btn-primary {
        font-size: 12px;
    }

    .footer-msg {
        font-size: 13px;
        line-height: 25px;
    }

    .cloudofferinglayout {
        /* height: 150vh */
    }

    .BigDataOfferings {
        gap: 10px;
    }

    .rowgap {
        gap: 10px;
    }

    .discover-button {
        width: 100%;
        height: 100%;
        padding: 15px 5px;
    }

    .discover-icon {
        width: 15px;
    }

    .discover-text {
        margin-top: 5px;
        font-size: 10px;
    }

    .font-caption {
        font-size: 10px;
        /* letter-spacing: 0px; */
    }

    .center-button-banner {
        height: 30px;
        width: -moz-fit-content;
        width: fit-content;
        padding: 0px 20px;
    }

    .button-center-banner.btn.btn-primary {
        font-size: 10px;
    }
}

@media(min-width: 567px) {
    .accordion {
        width: 40vw;
    }

    .accordiancontent {
        justify-content: center;
    }

    .content-services {
        font-size: 50px;
    }

    .sub-header {
        font-size: 18px;
        line-height: 35px;
    }

    .center-button {
        height: 61px;
        width: 292.24px;
    }

    .center-button-banner {
        height: 50px;
        width: 245px;
    }

    .center-button-accordian {
        width: -moz-fit-content;
        width: fit-content;
        height: -moz-fit-content;
        height: fit-content;
    }

    .buttoncontainer {
        margin-top: 7rem;
    }

    .imageoverlay {
        height: 24%;
        margin: 0px 20px 10px 10px;
        border-radius: 20px;
    }

    .button-center.btn.btn-primary {
        font-size: 19.14px;
    }

    .footer-msg {
        font-size: 16px;
        line-height: 40px;
    }

    .cloudofferinglayout {
        /* height: 50vh; */
    }

    .BigDataOfferings {
        gap: 30px;
    }

    .rowgap {
        gap: 0px
    }

    .discover-button {
        width: 100px;
        height: 100px;
        padding: 15px 10px;
    }

    .discover-icon {
        width: 20px;
    }

    .discover-text {
        margin-top: 5px;
        font-size: 14px;
    }

    .font-caption {
        font-size: 15px;
        /* letter-spacing: -1.67px; */
    }
}

.button-center-banner.btn.btn-primary,
.button-center.btn.btn-primary {
    box-shadow: 0px 10px 51.95px 0px #3A1E4B;
    --bs-btn-active-border-color: #B86BEB;
    --bs-btn-border-color: #B86BEB;
    --bs-btn-border-width: 1.2px;
    /* --bs-btn-bg: transparent; */
    --bs-btn-bg: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%);
    /* font-size: 19.14px; */
    border: 1.2px solid #B86BEB;
    border-radius: 50px;
    /* background: rgba(34, 29, 65, 0.5); */
    /* background: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%); */
    background:
        rgba(58, 30, 75, 0.5);
    /* justify-content: center;
    align-content: center; */

}


.button-center {
    /* display: flex;
    justify-content: center;
    align-items: center; */
    /* margin: 0; */
    position: absolute;
    /* top: 80%;
    left: 50%; */
    transform: translate(-50%, -50%);
    justify-content: center;
    align-content: center;
}


.buttoncontainer {
    /* height: 100%; */
    /* position: relative; */
    justify-content: center;
    align-content: center;
    bottom: 10px;
}

.buttoncontainer-extra {
    /* height: 100%; */
    position: relative;
    bottom: 6vh;
    padding-bottom: 9vh;
}

/* 
.center-button {
    height: 61px;
    width: 292.24px;
    border-radius: 50%;
} */


.overlaycontainer {
    position: relative;
    /* width: 50%; */
}

.image {
    display: block;
    width: 100%;
    height: auto;
}

.imageoverlay {
    position: absolute;
    bottom: 0;
    top: 25;
    /* background-color: #008CBA; */
    overflow: hidden;
    /* margin: 0px 20px 10px 10px; */
    width: 95%;
    /* height: 25%; */
    transition: .5s ease;
    text-align: center;
    justify-content: center;
    align-items: center;
    /* border-radius: 20px; */
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),
        linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),
        linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8));
    opacity: 85%;
}

.overlaycontainer:hover .imageoverlay {
    border-radius: 10%;
    height: 55%;
}

.overlaycontainer:hover .overlaytext {
    top: 50%;
}

/* @media (min-width: 576px) {
    .container, .container-sm {
        max-width: 690px;
    }
} */

@media (min-width: 200px) {
    .overlaytext {
        /* padding:5px; */
        font-weight: 400;
        font-size: 10px;
        /* width: 25vw;
        height: 13vh; */
        width: 100%;
        height: 100%;
        overflow-y: scroll;
    }

    .overlaycontainer:hover .paragraph {
        font-weight: 250;
        font-size: 7px;
        /* letter-spacing: 1px; */
    }

    .accordianimage {
        width: 35vw;
        height: auto;
        top: 5px;
        gap: 0px;
        justify-content: center;
    }

    .accordion-button,
    .accordion-button.collapsed {
        font-size: 15px !important;
    }

    .accordion-body {
        font-size: 13px;
        --bs-accordion-body-padding-y: 0.5rem;
        --bs-accordion-body-padding-x: 1.25rem;
    }

    .container,
    .container-sm {
        min-width: 100%;
    }
}

@media (min-width: 300px) {
    .overlaytext {
        /* padding:5px; */
        font-weight: 400;
        font-size: 6px;
        /* width: 25vw;
        height: 13vh; */
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        padding: 3px 10px !important;
    }

    .overlaycontainer:hover .paragraph {
        font-weight: 300;
        font-size: 5px;
        /* letter-spacing: 1px; */
    }

    .accordianimage {
        width: 49vw;
        height: auto;
        /* top: 5px; */
        gap: 0px;
        /* opacity: 1; */
        justify-content: center;
        align-items: center;
    }

    .accordion-button,
    .accordion-button.collapsed {
        font-size: 17px !important;
        --bs-accordion-btn-padding-y: 0.5rem;
    }

    .accordion-body {
        font-size: 13px;
        --bs-accordion-body-padding-y: 0.5rem;
        --bs-accordion-body-padding-x: 1rem;
    }

    .container,
    .container-sm {
        min-width: 100%;
    }
}

@media (min-width: 400px) {
    .overlaytext {
        /* padding:5px; */
        font-weight: 400;
        font-size: 10px;
        /* width: 25vw;
        height: 13vh; */
        width: 100%;
        height: 100%;
        overflow-y: scroll;
    }

    .overlaycontainer:hover .paragraph {
        font-weight: 250;
        font-size: 9px;
        /* letter-spacing: 1px; */
    }

    .accordianimage {
        width: 49vw;
        height: auto;
        /* top: 5px; */
        gap: 0px;
        /* opacity: 1; */
        justify-content: center;
        align-items: center;
    }

    .accordion-button,
    .accordion-button.collapsed {
        font-size: 15px !important;
        --bs-accordion-btn-padding-y: 1rem;
    }

    .accordion-body {
        font-size: 13px;
        --bs-accordion-body-padding-y: 0rem;
        --bs-accordion-body-padding-x: 1rem;
    }

    .container,
    .container-sm {
        min-width: 100%;
    }
}

@media (min-width: 576px) {
    .overlaytext {
        /* padding:5px; */
        font-weight: 400;
        font-size: 10px;
        /* width: 25vw;
        height: 13vh; */
        width: 100%;
        height: 100%;
        overflow-y: scroll;
    }

    .overlaycontainer:hover .paragraph {
        font-weight: 250;
        font-size: 9px;
        /* letter-spacing: 1px; */
    }

    .accordianimage {
        width: 45vw;
        height: auto;
        /* top: 5px; */
        gap: 0px;
        /* opacity: 1; */
        justify-content: center;
        align-items: center;
    }

    .accordion-button,
    .accordion-button.collapsed {
        font-size: 17px !important;
        --bs-accordion-btn-padding-y: 1rem;
    }

    .accordion-body {
        font-size: 13px;
        --bs-accordion-body-padding-y: 0.5rem;
        --bs-accordion-body-padding-x: 1.25rem;
    }

    .container,
    .container-sm {
        min-width: 100%;
    }
}

@media (min-width: 768px) {
    .overlaytext {
        padding: 5px;
        font-weight: 400;
        font-size: 15px;
        /* width: 25vw;
        height: 20vh; */
        width: 100%;
        height: 100%;
        overflow-y: scroll;
    }

    .overlaycontainer:hover .paragraph {
        font-weight: 250;
        font-size: 12px;
        /* letter-spacing: -1px; */
    }

    .accordianimage {
        width: 40vw;
        height: auto;
        /* top: 5px; */
        gap: 0px;
        /* opacity: 1; */
        justify-content: center;
    }

    .accordion-button,
    .accordion-button.collapsed {
        font-size: 18px !important;
        --bs-accordion-btn-padding-y: 1rem;
    }

    .accordion-body {
        font-size: 14px;
        --bs-accordion-body-padding-y: 0.5rem;
        --bs-accordion-body-padding-x: 1.25rem;
    }

    .container,
    .container-sm {
        min-width: 100%;
    }
}

@media (min-width: 992px) {
    .overlaytext {
        padding: 5px;
        font-weight: 600;
        font-size: 18px;
        /* width: 25vw;
        height: 24vh; */
        width: 100%;
        height: 100%;
        overflow-y: scroll;
    }

    .overlaycontainer:hover .paragraph {
        font-weight: 250;
        font-size: 12px;
        /* letter-spacing: -1px; */
    }

    .accordianimage {
        width: 40vw;
        height: auto;
        /* top: 5px; */
        gap: 0px;
        /* opacity: 1; */
    }

    .accordion-button,
    .accordion-button.collapsed {
        font-size: 20px !important;
        --bs-accordion-btn-padding-y: 1rem;
    }

    .accordion-body {
        font-size: 16px;
        --bs-accordion-body-padding-y: 1.50rem;
        --bs-accordion-body-padding-x: 1.25rem
    }
}

/* , min-width: 1200px, min-width: 576px,min-width: 768px */
@media (min-width: 1200px) {
    .overlaytext {
        position: relative;
        font-weight: 600;
        font-size: 18px;
        /* width: 23vw;
        height: 30vh; */
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        margin-top: 3%;
    }

    .overlaycontainer:hover .paragraph {
        font-weight: 600;
        font-size: 14px;
        /* letter-spacing: -1.34px; */
    }

    .accordianimage {
        width: 35vw;
        height: auto;
        top: 5px;
        gap: 0px;
        /* opacity: 1; */
    }

    .accordion-button,
    .accordion-button.collapsed {
        font-size: 20px !important;
    }

    .accordion-body {
        font-size: 16px;
        --bs-accordion-body-padding-y: 1.50rem;
        --bs-accordion-body-padding-x: 1.25rem
    }

    /* .overlaytext1 {
        justify-content: center;
        align-items: center;
    } */
}

@media (min-width: 1400px) {
    .overlaytext {
        position: relative;
        font-weight: 600;
        font-size: 20px;
        /* width: 23vw; */
        /* height: 30vh; */
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        /* margin-top: 3%; */
    }

    .overlaycontainer:hover .paragraph {
        font-weight: 600;
        font-size: 14px;
    }

    .accordianimage {
        width: 100%;
        height: 100%;
        top: 5px;
        gap: 0px;
        /* opacity: 1; */

    }

    .accordion-button {
        font-size: 20px !important;
        --bs-accordion-btn-padding-y: 0.5rem;
    }

    .accordion-body {
        font-size: 16px;
        --bs-accordion-body-padding-y: 1rem;
        --bs-accordion-body-padding-x: 1.25rem
    }

    /* .overlaytext1 {
        justify-content: center;
        align-items: center;
    } */
}

.overlaytext {
    color: rgba(255, 255, 255, 1);
    /* font-weight: 700;
    font-size: 19px; */
    font-family: "Roboto", sans-serif;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: left;
    /* width: 20vw; */
    /* height: 25vh; */
    gap: 0px;
    padding: 0px 10px;
    /* border-radius: 10%; */

    /* Big Data Infrastructure & Management: Building the Foundation for Insights */

    font-style: normal;

    color: #FFFFFF;


}


.paragraph {
    color: rgba(255, 255, 255, 0.7);
    /* font-weight: 600;
    font-size: 14px; */
    /* letter-spacing: -1.34px; */
    font-size: 0px;
    font-family: "Roboto", sans-serif;
    display: block;
}




.footer-msg {
    color: rgba(255, 255, 255, 1);
    /* font-size: 16px; */
    font-weight: 400;
    display: block;
    text-align: center;
    /* line-height: 27.3px; */
}

.footer-msg-logo {
    font-family: "Orbitron", sans-serif;
    color: #9e5ed2;
    /* font-size: 16px; */
    font-weight: 500;
    display: block;
    text-align: left;
    /* line-height: 27.3px; */
}

.footer-submsg {
    font-family: "Roboto";
    color: rgba(255, 255, 255, 1);
    font-size: 15px;
    font-weight: 400;
    z-index: 10;
    cursor: pointer;
}

.contact-logo {
    gap: 5%;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.Footercontact {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
}

.div-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.div-right {
    display: flex;
    justify-content: right;
    align-items: center;
}

.div-left {
    display: flex;
    justify-content: center;
    align-items: center;
}

.navbar-toggler {
    --bs-navbar-toggler-border-color: white;
    --bs-navbar-color: white;
}

.span.navbar-toggler-icon {
    /* --bs-navbar-toggler-icon-bg:  url(data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e); */
    --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});

}

.btn {
    --bs-btn-font-family: "Roboto", sans-serif;
    ;
    --bs-btn-font-size: 17px;
    --bs-btn-font-weight: 700;
}

.backgroundcolor {
    background: rgba(6, 0, 12, 1);
    width: 100%;
    height: auto;
}




/* Rectangle 1544 */

/* position: absolute;
width: 707.17px;
height: 436.14px;
left: -102.37px;
top: 210.5px;

background: rgba(0, 0, 0, 0.8);
filter: blur(55.0329px); */

.overlay-genai-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 30%;
    /* Adjust this to control how much of the bottom is covered */
    /* background: rgba(0, 0, 0, 0.8); */
    background-image: radial-gradient(circle, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.6));
    filter: blur(65.0329px);

}


.dropdown-toggle::after {
    display: none !important;
}




.dropdown-menu {
    --bs-body-bg: rgba(12, 23, 36, 1);
    --bs-border-radius: 24.16px;
    --bs-border-color-translucent: rgba(28, 31, 34, 1);
    box-shadow: 0px 36.24px 84.57px 0px rgba(167, 174, 186, 0.16);
    --bs-border-width: 1.51px;
    color: rgba(255, 255, 255, 1);
    --bs-dropdown-padding-y: 1rem !important;
    --bs-dropdown-padding-x: 1rem !important;
    /* display: flex !important;
flex-direction: column !important; */
}

.dropdown-item {
    --bs-dropdown-link-color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: 700;
    font-family: "Roboto", sans-serif;
    --bs-dropdown-item-padding-y: 0.50rem;
    --bs-dropdown-item-padding-x: 1rem;
    /* background: linear-gradient(270deg, rgba(23, 23, 23, 0.5) 0.26%, rgba(125, 24, 188, 0.5) 40.8%, rgba(23, 23, 23, 0.5) 102.25%); */
    margin: 10px 10px;
    gap: 15px;
    display: inline-flex;
}

.dropdown-item:focus,
.dropdown-item:hover {
    --bs-dropdown-link-hover-color: rgba(255, 255, 255, 1);
    --bs-dropdown-link-hover-bg: none;
    background: linear-gradient(270deg, rgba(23, 23, 23, 0.5) 0.26%, rgba(125, 24, 188, 0.5) 40.8%, rgba(23, 23, 23, 0.5) 102.25%) !important;
}


/* .App {
    font-family: sans-serif;
    text-align: center;
  } */

.cardContainer {
    background-color: blue;
    /*margin: 20px;*/
    display: flex;
    flex-direction: column;
    flex-grow: 2;
    align-items: center;
    box-shadow: 5px 4px 5px rgba(0, 0, 0, 0.4);
}

.titleContainer {
    background-color: white;
    display: flex;
    width: 100%;
    flex-direction: row;
    margin-top: 5px;
}

#title {
    flex-grow: 3;
    position: relative;
}

#rating {
    width: 40%;
    background-color: orange;
    flex-direction: row;
}

.cardImgContainer {
    background-color: green;
}

.cardImgContainer img {
    object-fit: fill;
}

.cardTextContainer {
    background-color: red;
}

.buttontransform {
    transition: transform 0.3s ease-in-out;
}

.buttontransform:hover {
    transform: rotate(-40deg);

}

.circlestyle {
    align-items: center;
    justify-content: center;
    width: 35px;
    /* Adjust size as needed */
    height: 35px;
    border-radius: 50%;
    /* Ensure the border is also circular */
    /* background: rgba(34, 29, 65, 0.5); */
    border: 1.45px solid #B86BEB;
    /* border-image-source: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%); */
    border-image-slice: 10;
    display: inline-flex;
}

.centericon {
    justify-content: center;
    align-items: center;
    align-content: center;
}

.dropdown-text {
    line-height: 32px; 
    margin: 0px 0px 5px 5px;
  }


 .flexrow-header {
    display: flex;
    flex-direction: row;
}
@media(min-width: 345px) and (max-width: 567px) {
    .flexrow-header {
        display: flex;
        flex-direction: column !important;
    }
}

.quadchainlogo {
    margin-left: 2%;
    height: 18vh;
    width: 15vw;
    position: absolute;
    left: 0;
  }
  
  /* Tablet (width between 600px and 1024px) */
@media (max-width: 1024px) {
    .quadchainlogo {
      width: 25vw;
      height: 12vh;
    }
  }
  
  /* Mobile (width below 600px) */
  @media (max-width: 600px) {
    .quadchainlogo {
      width: 40vw;
      height: 10vh;
      margin-left: 5%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Home.css"],"names":[],"mappings":"AAAA;IACI,6FAA6F;IAC7F,4FAA4F;IAC5F,2HAA2H;IAC3H,6FAA6F;;IAE7F,4FAA4F;IAC5F,yCAAyC;;IAEzC,oCAAoC;;IAEpC,mCAAmC;IACnC,wBAAwB;IACxB,gCAAgC;IAChC,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;;IAEhB;;;;kBAIc;;IAEd,yBAAyB;IACzB,yBAAyB;;IAEzB,uBAAuB;;IAEvB,wDAAwD;IACxD,mBAAmB;IACnB,wHAAwH;IACxH,4FAA4F;IAC5F,6FAA6F;IAC7F,6BAA6B;;AAEjC;;AAEA;IACI;mBACe;IACf,YAAY;IACZ,eAAe;IACf,oCAAoC;IACpC,QAAQ;IACR,UAAU;;AAEd;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;IACjC,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;;;;;GAQG;;AAEH;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,sEAAsE;;AAE1E;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,+BAA+B;IAC/B,8QAA8Q;;IAE9Q,4CAA4C;;AAEhD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;;;GAKG;AACH;IACI;;;2BAGuB;IACvB,oBAAoB;;AAExB;;;;AAIA;IACI;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;;;;;;OAMG;AACP;;AAEA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;;;;;;;SAOS;;AAET;IACI;QACI,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,YAAY;QACZ,+BAA+B;QAC/B,uBAAuB;QACvB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,YAAY;QACZ,+BAA+B;QAC/B,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,oCAAoC;QACpC,wCAAwC;QACxC,2BAA2B;QAC3B,iCAAiC;;IAErC;AACJ;;AAEA;;;;;;;;;;;;oCAYoC;;AAEpC;;;;;;;GAOG;;AAEH;IACI;QACI,YAAY;;IAEhB;;IAEA;QACI,WAAW;QACX,wHAAwH;QACxH,sBAAsB;QACtB,kBAAkB;QAClB,mBAAmB;QACnB,6BAA6B;QAC7B,qCAAqC;;QAErC,sBAAsB;;QAEtB,oCAAoC;QACpC,2DAA2D;;IAE/D;;IAEA;QACI,oCAAoC;QACpC,wCAAwC;;IAE5C;;IAEA;QACI,UAAU;IACd;;AAEJ;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BG;;AAEH;IACI,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;IAC1B,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;;IAEI,+BAA+B;;AAEnC;;AAEA;;;;;;;;;;;GAWG;AACH,8QAA8Q;;;;AAI9Q;IACI;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;QACtB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;QACtB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,iCAAiC;IACrC;AACJ;;;AAGA;;IAEI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI;iBACa;IACb;eACW;IACX,oBAAoB;IACpB;;;;yBAIqB;AACzB;;AAEA;;;;;GAKG;;AAEH;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB;oBACgB;IAChB,6DAA6D;;IAE7D,6BAA6B;IAC7B,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;;AAGA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA,qBAAqB;AACrB;IACI,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA;;;;;;;;;;GAUG;;AAEH;IACI,aAAa;IACb,cAAc;IACd,oEAAoE;AACxE;;;AAGA;IACI,mCAAmC;;IAEnC,mBAAmB;;;AAGvB;;AAEA,cAAc;AACd;;;;;;;;6CAQ6C;;;;AAI7C,mCAAmC;AACnC;IACI,kBAAkB;IAClB,yEAAyE;;IAEzE,8EAA8E;IAC9E,mDAAmD;IACnD,mFAAmF;AACvF;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,OAAO;IACP,WAAW;IACX,wBAAwB;IACxB,6DAA6D;AACjE;;AAEA;IACI,8DAA8D;IAC9D,6BAA6B;IAC7B,iCAAiC;IACjC,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,2DAA2D;IAC3D,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;AAC/B;;;AAGA;IACI,iCAAiC;IACjC;wBACoB;IACpB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;;;AAGlB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;;;;;6BAKyB;IACzB,eAAe;IACf,gCAAgC;IAChC,8BAA8B;IAC9B,+BAA+B;IAC/B,mDAAmD;;;AAGvD;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,2EAA0E;IAC1E,4BAA4B;IAC5B,8BAA8B;IAC9B,iBAAiB;;AAErB;;AAEA;IACI;QACI,wBAAwB;QACxB,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,4BAA4B;;IAEhC;;AAEJ;;AAEA;IACI;QACI,wBAAwB;QACxB,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,wBAAwB;;QAExB,4BAA4B;IAChC;;AAEJ;;AAEA;IACI;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,sBAAsB;IAC1B;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,2FAA2F;AAC/F;;;AAGA;IACI,kBAAkB;CACrB;;AAED;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,OAAO;IACP,wBAAwB;IACxB,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,gFAAgF;IAChF,sBAAsB;IACtB;oBACgB;IAChB;mBACe;IACf,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,8DAA8D;QAC1D,0BAA0B;QAC1B,qDAAqD;QACrD,8BAA8B;QAC9B;oBACY;QACZ,iBAAiB;QACjB;;;sBAGc;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,wBAAwB;IACxB;oBACgB;IAChB,yDAA0D;IAC1D,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB;4CACwC;AAC5C;;AAEA;IACI,8BAA8B;IAC9B,4CAA4C;IAC5C,yBAAyB;IACzB,gBAAgB;IAChB,iCAAiC;IACjC,mCAAmC;;;AAGvC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,qCAAqC;IACrC,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;IACrC,gCAAgC;IAChC,iCAAiC;IACjC,sBAAsB;IACtB,mCAAmC;IACnC,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;GAEG;;;AAGH;IACI,kCAAkC;IAClC,qCAAqC;IACrC,qBAAqB;IACrB,iCAAiC;IACjC,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,gEAAuD;;IAEvD,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,uEAA+D;IAC/D,0EAAiE;AACrE;;AAEA;;;;;GAKG;;AAEH;IACI,yCAAyC;AAC7C;;;;AAIA;IACI;oBACgB;IAChB;mBACe;IACf;;mBAEe;;AAEnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;;AAEjC;;AAEA;IACI,uBAAuB;IACvB,mCAAmC;AACvC;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,0BAA0B;QAC1B,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,0BAA0B;QAC1B,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,uBAAkB;QAAlB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,uBAAkB;QAAlB,kBAAkB;QAClB,wBAAmB;QAAnB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,0BAA0B;QAC1B,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,6BAA6B;IACjC;AACJ;;AAEA;;IAEI,wCAAwC;IACxC,qCAAqC;IACrC,8BAA8B;IAC9B,4BAA4B;IAC5B,8BAA8B;IAC9B,8DAA8D;IAC9D,wBAAwB;IACxB,2BAA2B;IAC3B,mBAAmB;IACnB,uCAAuC;IACvC,mEAAmE;IACnE;6BACyB;IACzB;4BACwB;;AAE5B;;;AAGA;IACI;;0BAEsB;IACtB,eAAe;IACf,kBAAkB;IAClB;gBACY;IAEZ,gCAAgC;IAChC,uBAAuB;IACvB,qBAAqB;AACzB;;;AAGA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;;;;;GAKG;;;AAGH;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,+BAA+B;IAC/B,gBAAgB;IAChB,gCAAgC;IAChC,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB;;qEAEiE;IACjE,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,QAAQ;AACZ;;AAEA;;;;GAIG;;AAEH;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,eAAe;QACf;uBACe;QACf,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,QAAQ;QACR,uBAAuB;IAC3B;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,qCAAqC;QACrC,sCAAsC;IAC1C;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;QACd;uBACe;QACf,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,QAAQ;QACR,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;;QAEI,0BAA0B;QAC1B,oCAAoC;IACxC;;IAEA;QACI,eAAe;QACf,qCAAqC;QACrC,mCAAmC;IACvC;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,eAAe;QACf;uBACe;QACf,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,QAAQ;QACR,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;;QAEI,0BAA0B;QAC1B,kCAAkC;IACtC;;IAEA;QACI,eAAe;QACf,mCAAmC;QACnC,mCAAmC;IACvC;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,eAAe;QACf;uBACe;QACf,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,QAAQ;QACR,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;;QAEI,0BAA0B;QAC1B,kCAAkC;IACtC;;IAEA;QACI,eAAe;QACf,qCAAqC;QACrC,sCAAsC;IAC1C;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf;uBACe;QACf,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,QAAQ;QACR,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;;QAEI,0BAA0B;QAC1B,kCAAkC;IACtC;;IAEA;QACI,eAAe;QACf,qCAAqC;QACrC,sCAAsC;IAC1C;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf;uBACe;QACf,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,QAAQ;QACR,gBAAgB;IACpB;;IAEA;;QAEI,0BAA0B;QAC1B,kCAAkC;IACtC;;IAEA;QACI,eAAe;QACf,sCAAsC;QACtC;IACJ;AACJ;;AAEA,2DAA2D;AAC3D;IACI;QACI,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf;uBACe;QACf,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,QAAQ;QACR,gBAAgB;IACpB;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,sCAAsC;QACtC;IACJ;;IAEA;;;OAGG;AACP;;AAEA;IACI;QACI,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,QAAQ;QACR,gBAAgB;;IAEpB;;IAEA;QACI,0BAA0B;QAC1B,oCAAoC;IACxC;;IAEA;QACI,eAAe;QACf,mCAAmC;QACnC;IACJ;;IAEA;;;OAGG;AACP;;AAEA;IACI,6BAA6B;IAC7B;sBACkB;IAClB,iCAAiC;IACjC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAGT,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;IACjB,wBAAwB;;IAExB,+EAA+E;;IAE/E,kBAAkB;;IAElB,cAAc;;;AAGlB;;;AAGA;IACI,+BAA+B;IAC/B;sBACkB;IAClB,6BAA6B;IAC7B,cAAc;IACd,iCAAiC;IACjC,cAAc;AAClB;;;;;AAKA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,wBAAwB;AAC5B;;AAEA;IACI,4SAA4S;IAC5S,oEAAsS;;AAE1S;;AAEA;IACI,0CAA0C;;IAE1C,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;AAChB;;;;;AAKA,mBAAmB;;AAEnB;;;;;;;0BAO0B;;AAE1B;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,6DAA6D;IAC7D,oCAAoC;IACpC,qGAAqG;IACrG,uBAAuB;;AAE3B;;;AAGA;IACI,wBAAwB;AAC5B;;;;;AAKA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,kDAAkD;IAClD,6DAA6D;IAC7D,yBAAyB;IACzB,6BAA6B;IAC7B,wCAAwC;IACxC,wCAAwC;IACxC;oCACgC;AACpC;;AAEA;IACI,gDAAgD;IAChD,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,qCAAqC;IACrC,kCAAkC;IAClC,oIAAoI;IACpI,iBAAiB;IACjB,SAAS;IACT,oBAAoB;AACxB;;AAEA;;IAEI,sDAAsD;IACtD,iCAAiC;IACjC,yIAAyI;AAC7I;;;AAGA;;;KAGK;;AAEL;IACI,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,uCAAuC;IACvC,4BAA4B;IAC5B,4EAA4E;IAC5E,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;EACzB;;;CAGD;IACG,aAAa;IACb,mBAAmB;AACvB;AACA;IACI;QACI,aAAa;QACb,iCAAiC;IACrC;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,OAAO;EACT;;EAEA,4CAA4C;AAC9C;IACI;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA,+BAA+B;EAC/B;IACE;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;EACF","sourcesContent":[".bg-body-tertiary {\n    /* background: linear-gradient(114.88deg, #06000C -2.45%, #06000C 58.38%, #06000C 101.84%); */\n    /* background: linear-gradient(267.03deg, #00F0FF 4.01%, #5200FF 57.55%, #FF2DF7 114.97%); */\n    /* background: linear-gradient(114.88deg, rgba(6, 0, 12, 1) -2.45%, rgba(6, 0, 12, 1) 58.38%, rgba(6, 0, 12, 1) 101.84%); */\n    /* background: linear-gradient(114.88deg, #06000C -2.45%, #06000C 58.38%, #06000C 101.84%); */\n\n    /* background: linear-gradient(267.03deg, #00F0FF 4.01%, #5200FF 57.55%, #FF2DF7 114.97%); */\n    /* background-color: rgba(6, 0, 12, 1); */\n\n    /* background: #06000C !important; */\n\n    /* --bs-tertiary-bg-rgb:#06000C;  */\n    /* --bs-bg-opacity: 0; */\n    border-bottom: 1px solid #5E2C8C;\n    /* --bs-body-bg:#06000C; */\n    /* Group 33092 */\n    /* Ellipse 874 */\n\n    /* position: absolute;\n    width: 1779px;\n    height: 516px;\n    left: 57px;\n    top: -206px; */\n\n    /* background: #11011F; */\n    /* filter: blur(100px); */\n\n    /* overflow: visible; */\n\n    box-shadow: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n    box-shadow: #B86BEB;\n    background: linear-gradient(114.88deg, rgba(0, 10, 31, 1) -2.45%, rgba(17, 1, 31, 1) 58.38%, rgba(0, 10, 31, 1) 101.84%);\n    /* background: linear-gradient(267.03deg, #00F0FF 4.01%, #00F0FF 57.55%, #00F0FF 114.97%); */\n    /* background: linear-gradient(114.88deg, #00F0FF -2.45%, #5200FF 58.38%, #FF2DF7 101.84%); */\n    /* filter: blur(385.133px); */\n\n}\n\n.arrow-button {\n    /* width: 30px;\n    height: 20px; */\n    top: 52.57px;\n    left: 1303.53px;\n    padding: 3.29px 2.63px 3.29px 2.63px;\n    gap: 0px;\n    opacity: 1;\n\n}\n\n.company {\n    /* background:  rgba(6, 0, 12, 1); */\n    background: rgba(36, 36, 36, 0.2);\n    display: flex;\n    flex-direction: row;\n}\n\n/* \n.company-icon {\n    width: Fill (223px)px;\n    height: Hug (72px)px;\n    padding: 16px 30px 16px 0px;\n    gap: 2px;\n    opacity: 0px;\n\n} */\n\n.header {\n    height: 14vh;\n}\n\n.outlineButton {\n    border: 0.85px solid red;\n    border-color: #0C0611;\n    border-image-source: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%);\n\n}\n\n.btn:hover {\n    --bs-btn-hover-color: white;\n    --bs-btn-hover-bg: transparent;\n}\n\n.btn-primary {\n    --bs-btn-color: white;\n    --bs-btn-bg: transparent;\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 700;\n    font-size: 17px;\n}\n\n.btn {\n    --bs-border-radius: 20px;\n    --bs-btn-border-radius: 22px;\n    --bs-btn-bg: transparent;\n}\n\n.font-header {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 800;\n    /* font-size: 55px; */\n    text-align: left;\n}\n\n.font-caption {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 400;\n    /* font-size: 15px; */\n    text-align: left;\n    color: rgba(255, 255, 255, 0.7);\n    /* We leverage Big Data and Hadoop technologies to handle the three key areas of data: Variety, Volume, and Velocity. By employing distributed storage and computation, we deliver efficient solutions, including enterprise data lakes and real-time streaming applications */\n\n    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n\n}\n\n.carousel-indicators [data-bs-target] {\n    display: none !important;\n}\n\n/* .dropdown{\n    color: white;\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 700;\n    font-size: 17px;\n} */\n.navbar-collapse.collapse.show {\n    /* text-align: left;    \n    display: flex;\n    justify-content: center; \n    align-items: center;  */\n    /* padding: 10px;  */\n\n}\n\n\n\n.navbar-toggler-icon {\n    --bs-navbar-toggler-icon-bg: url(\"./Images/toggle.svg\")\n}\n\n@media (min-width: 1400px) {\n    .brandspacing {\n        margin-left: 100px;\n    }\n\n    /* .companyreiconsponsive {\n        width: 200vw;\n        height: 10vh;\n        gap: 30px;\n        opacity: 0px;\n        padding: 16px, 30px, 16px, 30px;\n    } */\n}\n\n/* @media (min-width: 1200px) {\n    .companyreiconsponsive {\n        width: 16vw;\n        height: 10vh;\n        gap: 10px;\n        opacity: 0px;\n        padding: 16px, 30px, 16px, 30px;\n    }\n}\n@media (min-width: 992px) { \n.companyreiconsponsive {\n    width: 5vw;\n    height: 10vh;\n    gap: 0px;\n    opacity: 0px;\n    padding: 16px, 30px, 16px, 30px;\n}\n} */\n\n/* @media (min-width: 768px) { \n    .companyreiconsponsive {\n        width: 16vw;\n        height: 10vh;\n        gap: 0px;\n        opacity: 0px;\n        padding: 16px, 30px, 16px, 30px;\n    } } */\n\n@media (min-width: 576px) {\n    .companyreiconsponsive {\n        width: 16vw;\n        height: 13vh;\n        gap: 0px;\n        opacity: 0px;\n        padding: 16px, 30px, 16px, 30px;\n        justify-content: center;\n        align-items: center;\n    }\n}\n\n@media (max-width: 300px) {\n    .companyreiconsponsive {\n        width: 16vw;\n        height: 13vh;\n        gap: 0px;\n        opacity: 0px;\n        padding: 16px, 30px, 16px, 30px;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .dropdown-menu {\n        --bs-body-bg: transparent !important;\n        --bs-dropdown-padding-x: 0rem !important;\n        box-shadow: none !important;\n        --bs-border-width: 0px !important;\n\n    }\n}\n\n/* @media (min-width: 576px) { ... }\n\n// Medium devices (tablets, 768px and up)\n@media (min-width: 768px) { ... }\n\n// Large devices (desktops, 992px and up)\n@media (min-width: 992px) { ... }\n\n// Extra large devices (large desktops, 1200px and up)\n@media (min-width: 1200px) { ... }\n\n// Extra extra large devices (larger desktops, 1400px and up)\n@media (min-width: 1400px) { ... } */\n\n/* .company-icon {\n    width: Fill (223px)px;\n    height: Hug (72px)px;\n    padding: 16px 30px 16px 0px;\n    gap: 2px;\n    opacity: 0px;\n\n} */\n\n@media (max-width: 992px) {\n    .header {\n        height: 18vh;\n\n    }\n\n    .navbar-collapse.collapse.show {\n        z-index: 10;\n        background: linear-gradient(114.88deg, rgba(0, 10, 31, 1) -2.45%, rgba(17, 1, 31, 1) 58.38%, rgba(0, 10, 31, 1) 101.84%);\n        border-radius: 24.16px;\n        padding: 1rem 0rem;\n        border-radius: 10px;\n        color: rgba(255, 255, 255, 1);\n        border: 1px solid rgba(28, 31, 34, 1);\n\n        box-sizing: border-box;\n\n        transition: opacity 0.5s ease-in-out;\n        box-shadow: 0px 44.3094px 103.389px rgba(125, 24, 188, 0.2);\n\n    }\n\n    .dropdown-menu {\n        --bs-body-bg: transparent !important;\n        --bs-dropdown-padding-x: 0rem !important;\n\n    }\n\n    .demo {\n        width: 80%;\n    }\n\n}\n\n\n/* .dropdown-menu {\n    --bs-body-bg: rgba(23, 23, 23, 1);\n    --bs-border-radius: 24.16px;\n    --bs-border-color-translucent: rgba(28, 31, 34, 1);\n    box-shadow: 0px 36.24px 84.57px 0px rgba(167, 174, 186, 0.16);\n    --bs-border-width: 1.51px;\n    color: rgba(255, 255, 255, 1);\n    --bs-dropdown-padding-y: 1rem !important;\n    --bs-dropdown-padding-x: 1rem !important;\n\n}\n\n.dropdown-item {\n    --bs-dropdown-link-color: rgba(255, 255, 255, 1);\n    font-size: 16px;\n    font-weight: 700;\n    font-family: \"Roboto\", sans-serif;\n    --bs-dropdown-item-padding-y: 0.50rem;\n    --bs-dropdown-item-padding-x: 1rem;\n    margin: 10px 0px;\n}\n\n.dropdown-item:focus,\n.dropdown-item:hover {\n    --bs-dropdown-link-hover-color: rgba(255, 255, 255, 1);\n    --bs-dropdown-link-hover-bg: none;\n    background: linear-gradient(270deg, rgba(23, 23, 23, 0.5) 0.26%, rgba(125, 24, 188, 0.5) 40.8%, rgba(23, 23, 23, 0.5) 102.25%) !important;\n} */\n\n.nav-link {\n    line-height: 27.3px;\n    color: white;\n    --bs-nav-link-color: white;\n    font-family: \"Roboto\", sans-serif;\n    --bs-nav-link-font-weight: 700;\n    --bs-nav-link-font-size: 17px;\n}\n\n.nav-link:hover {\n    color: white;\n    --bs-nav-link-hover-color: white;\n}\n\n.nav-link:focus {\n    color: white;\n    --bs-nav-link-focus-color: white;\n}\n\n.navbar-expand-xxl .navbar-nav .nav-link {\n    --bs-navbar-nav-link-padding-x: 25px;\n    font-weight: 800;\n}\n\n.navbar-nav .nav-link.active,\n.navbar-nav .nav-link.show {\n    --bs-navbar-active-color: white;\n\n}\n\n/* .dropdown-button-no-caret, .dropdown-button-no-caret:focus{\n    background-color: transparent;\n    color: white;\n    border: none;\n}\n.dropdown-button-no-caret:hover{\n    background-color: white;\n}\n\n.dropdown-button-no-caret::after{\n    display: none !important;\n} */\n/* We leverage Big Data and Hadoop technologies to handle the three key areas of data: Variety, Volume, and Velocity. By employing distributed storage and computation, we deliver efficient solutions, including enterprise data lakes and real-time streaming applications */\n\n\n\n@media (min-width: 300px) {\n    .CarouselHeader {\n        width: 100%;\n    }\n\n    .carousel-caption {\n        bottom: 0% !important;\n        left: 10% !important;\n    }\n\n    .font-header {\n        font-size: 13px;\n    }\n\n    .font-caption {\n        line-height: 15px;\n        width: 100% !important;\n        /* margin-left: 2vw !important; */\n    }\n}\n\n@media (min-width: 345px) {\n    .CarouselHeader {\n        width: 100%;\n    }\n\n    .carousel-caption {\n        bottom: 0% !important;\n        left: 10% !important;\n    }\n\n    .font-header {\n        font-size: 17px;\n    }\n\n    .font-caption {\n        line-height: 17px;\n        width: 100% !important;\n        /* margin-left: 2vw !important; */\n    }\n}\n\n@media (min-width: 400px) {\n    .CarouselHeader {\n        width: 100%;\n    }\n\n    .carousel-caption {\n        bottom: 1% !important;\n        left: 10% !important;\n    }\n\n    .font-header {\n        font-size: 20px;\n    }\n\n    .font-caption {\n        line-height: 19px;\n        width: 90% !important;\n        /* margin-left: 2vw !important; */\n    }\n}\n\n@media (min-width: 450px) {\n    .CarouselHeader {\n        width: 100%;\n    }\n\n    .carousel-caption {\n        bottom: 1% !important;\n        left: 10% !important;\n    }\n\n    .font-header {\n        font-size: 25px;\n    }\n\n    .font-caption {\n        line-height: 20px;\n        width: 90% !important;\n        /* margin-left: 2vw !important; */\n    }\n}\n\n@media (min-width: 576px) {\n    .CarouselHeader {\n        width: 100%;\n    }\n\n    .carousel-caption {\n        bottom: 5% !important;\n        left: 10% !important;\n    }\n\n    .font-header {\n        font-size: 30px;\n    }\n\n    .font-caption {\n        line-height: 23px;\n        width: 70% !important;\n        /* margin-left: 2vw !important; */\n    }\n}\n\n@media (min-width: 600px) {\n    .CarouselHeader {\n        width: 100%;\n    }\n\n    .carousel-caption {\n        bottom: 10% !important;\n        left: 10% !important;\n    }\n\n    .font-header {\n        font-size: 35px;\n    }\n\n    .font-caption {\n        line-height: 23px;\n        width: 65% !important;\n        /* margin-left: 2vw !important; */\n    }\n}\n\n@media (min-width: 768px) {\n    .CarouselHeader {\n        width: 100%;\n    }\n\n    .carousel-caption {\n        bottom: 13% !important;\n        left: 10% !important;\n    }\n\n    .font-header {\n        font-size: 45px;\n    }\n\n    .font-caption {\n        line-height: 23px;\n        width: 40% !important;\n        /* margin-left: 2vw !important; */\n    }\n}\n\n@media (min-width: 992px) {\n    .CarouselHeader {\n        width: 100%;\n    }\n\n    .carousel-caption {\n        bottom: 30% !important;\n        left: 10% !important;\n    }\n\n    .font-header {\n        font-size: 55px;\n    }\n\n    .font-caption {\n        line-height: 23px;\n        width: 40% !important;\n        /* margin-left: 2vw !important; */\n    }\n}\n\n@media (min-width: 1200px) {\n    .CarouselHeader {\n        width: 70%;\n    }\n\n    .carousel-caption {\n        bottom: 20% !important;\n        left: 10% !important;\n    }\n\n    .font-header {\n        font-size: 55px;\n    }\n\n    .font-caption {\n        line-height: 23px;\n        width: 40% !important;\n        /* margin-left: 2vw !important; */\n    }\n}\n\n@media (min-width: 1400px) {\n    .CarouselHeader {\n        width: 40%;\n    }\n\n    .carousel-caption {\n        bottom: 20% !important;\n        left: 8% !important;\n    }\n\n    .font-header {\n        font-size: 55px;\n    }\n\n    .font-caption {\n        line-height: 23px;\n        width: 40% !important;\n        /* margin-left: 2vw !important; */\n    }\n}\n\n\n.carousel-control-next-icon,\n.carousel-control-prev-icon {\n    width: 0rem !important;\n    height: 0rem !important;\n}\n\n.carousel-caption {\n    /* position: absolute;\n    right: 15%; */\n    /* bottom: 50%;\n    left: 5%; */\n    /* color: #7D18BC; */\n    /* left: 15%;\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n    color: #fff;\n    text-align: center; */\n}\n\n/* .carousel-item-next,\n.carousel-item-prev,\n.carousel-item.active {\n    margin-bottom: -5%;\n    margin-top: -5%;\n} */\n\n.discover-button {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    /* width: 100px;\n    height: 100px; */\n    background: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%);\n    ;\n    /* Example background color */\n    border-radius: 50%;\n    /* Makes the div a circle */\n    color: #ffffff;\n    /* Text color */\n    text-align: center;\n    cursor: pointer;\n    /* Optional: Cursor style */\n}\n\n.discover-icon {\n    font-size: 24px;\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 400;\n    font-size: 11px;\n    color: rgba(255, 255, 255, 1);\n}\n\n\n.flexColumn {\n    display: flex;\n    flex-direction: row !important;\n}\n\n/* CustomNavbar.css */\n.custom-dropdown .dropdown-toggle::after {\n    /* content: url('./Images/dropdownarrow.svg');  */\n    margin-left: 0.5em;\n}\n\n/* .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: 0em solid !important;\n    border-right: 0em solid transparent;\n    border-bottom: 0;\n    border-left: 0em solid transparent;\n    content: url('./Images/dropdownarrow.svg'); \n} */\n\n.navbar {\n    margin-top: 0;\n    padding-top: 0;\n    /* --bs-navbar-toggler-icon-bg: url('./Images/dropdownarrow.svg'); */\n}\n\n\n.content {\n    /* background: rgba(6, 0, 12, 1); */\n\n    background: #08080A;\n\n\n}\n\n/* Section 1 */\n/* \nposition: absolute;\nleft: -5.41%;\nright: -3.59%;\ntop: 47.58%;\nbottom: 32.82%;\n\nbackground: linear-gradient(180deg, #101019 0%, #101019 63.16%);\ntransform: matrix(1, 0.02, -0.02, 1, 0, 0); */\n\n\n\n/* transition: opacity .15s ease; */\n.underlinetext {\n    position: relative;\n    /* background-image: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%); */\n\n    /* text-decoration-color: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%); */\n    /* background: linear-gradient(#e66465, #9198e5); */\n    /* background-image: linear-gradient(90deg,rgb(98,60,49)0,rgb(255,255,255) 100%); */\n}\n\n.underlinetext::before {\n    content: \"\";\n    position: absolute;\n    top: 80%;\n    width: 100%;\n    left: 0;\n    height: 5px;\n    /* border-radius: 2px; */\n    background: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%);\n}\n\n.content-services {\n    /* color: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%); */\n    color: rgba(255, 255, 255, 1);\n    font-family: \"Roboto\", sans-serif;\n    /* font-size: 50px; */\n    font-weight: 100;\n    line-height: 81.71px;\n}\n\n.gradient-text {\n    background-image: linear-gradient(180deg, #B86BEB, #7D18BC);\n    -webkit-background-clip: text;\n    /* For Safari/Chrome */\n    background-clip: text;\n    /* Standard property */\n    color: transparent;\n    /* Hide the original text */\n}\n\n\n.sub-header {\n    font-family: \"Roboto\", sans-serif;\n    /* font-size: 18px;\n    line-height: 35px; */\n    font-weight: 300;\n    letter-spacing: -0.006em;\n    text-align: center;\n    color: #E6E6E6;\n\n\n}\n\n.bg-layout {\n    position: relative;\n    overflow: visible;\n    /* width: 828.66px;\nheight: 809.31px;\ntop: 974px;\nleft: 1007.27px;\ngap: 0px;\nborder: 3.54px 0px 0px 0px; */\n    opacity: 0.05px;\n    /* background-position: right; */\n    /* background-position: 50%; */\n    /* transform: rotate(-45deg); */\n    /* background-image: url('./Images/bg-imge.svg'); */\n\n\n}\n\n.bg-layout::before {\n\n    content: \"\";\n    position: absolute;\n    bottom: 10vh;\n    width: 100%;\n    height: 38vh;\n    background: url('./Images/genaiofferrings-bg.svg') no-repeat center center;\n    /* background-size: cover; */\n    /* background-size: contain; */\n    object-fit: cover;\n\n}\n\n@media(max-width: 567px) {\n    .bg-layout::before {\n        background-size: contain;\n        top: -20vh;\n    }\n\n    .bigdatafferinglayout::before {\n        background-size: contain;\n        background-repeat: no-repeat;\n\n    }\n\n}\n\n@media(max-width: 944px) {\n    .bg-layout::before {\n        background-size: contain;\n        top: -19vh;\n    }\n\n    .bigdatafferinglayout::before {\n        width: 40vw;\n        height: 100%;\n        background-size: contain;\n\n        background-repeat: no-repeat;\n    }\n\n}\n\n@media(min-width: 945px) {\n    .bg-layout::before {\n        background-size: cover;\n        top: -25vh;\n    }\n\n    .bigdatafferinglayout::before {\n        width: 40vw;\n        height: 100%;\n        background-size: cover;\n    }\n}\n\n.oval-shade {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    filter: blur(50px);\n    /* left: -15vh; */\n    z-index: -10;\n    background: radial-gradient(ellipse at center, rgba(125, 24, 188, 0.3) 0%, transparent 80%);\n}\n\n\n.cloudofferinglayout {\n    position: relative;\n }\n\n.cloudofferinglayout::before {\n    content: \"\";\n    position: absolute;\n    top: 0%;\n    left: 0;\n    background-position: top;\n    background-repeat: no-repeat;\n    width: 100%;\n    height: 100%;\n    /* background: url('./Images/cloudofferrings-bg.svg') no-repeat center center; */\n    background-size: cover;\n    /* width: 3722px;\n    height: 909px; */\n    /* top: 1902px;\n    left: -332px; */\n    gap: 0px;\n    opacity: 0px;\n    /* z-index: 2; */\n    background: linear-gradient(180deg, #101019 0%, #101019 63.16%)\n        /* Adjust size as needed */\n        /* transform: translate(-50%, -50%) rotate(45deg);  */\n        /* transform: rotate(25deg); */\n        /* width: 830.33px;\n    height: 880px; */\n        /* top: 2031px; */\n        /* left: -169.33px;\n    gap: 0px;\n    border: 1.46px 0px 0px 0px;\n    opacity: 0.05px; */\n}\n\n.bigdatafferinglayout {\n    position: relative;\n    padding: 0px 10px;\n\n}\n\n.bigdatafferinglayout::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-position: top;\n    /* width: 40vw;\n    height: 110vh; */\n    background-image: url('./Images/bigdataofferrings-bg.svg');\n    /* background-repeat: repeat-x; */\n    /* background-size: contain; */\n}\n\n.accordion-body {\n    /* font-weight: 100; */\n    /* font-size: 16px; */\n    text-align: left;\n    /* --bs-accordion-body-padding-y: 1.50rem;\n    --bs-accordion-body-padding-x: 1.25rem */\n}\n\n.accordion-item {\n    --bs-accordion-bg: transparent;\n    --bs-accordion-color: rgba(249, 249, 249, 1);\n    --bs-body-font-size: 18px;\n    font-weight: 300;\n    font-family: \"Roboto\", sans-serif;\n    /* border-top: 1px solid #B86BEB; */\n\n\n}\n\n.accordion-item:first-of-type>.accordion-header .accordion-button {\n    border: none;\n}\n\n.accordion-item .accordion-header .accordion-button {\n    border-top: 1px solid #B86BEB;\n    z-index: 10;\n}\n\n.accordian-item.collapsed {\n    --bs-accordion-btn-bg: transparent;\n    --bs-accordion-active-bg: transparent;\n    /* border: 1px solid #B86BEB; */\n}\n\n.accordion-item:not(.collapsed) {\n    --bs-accordion-active-bg: transparent;\n    /* border-top: 1px solid #B86BEB; */\n}\n\n.accordion-button::after {\n    --bs-accordion-btn-bg: transparent;\n    --bs-accordion-active-bg: transparent;\n}\n\n.accordion-button.collapsed {\n    --bs-accordion-color: #F9F9F9;\n    --bs-accordion-btn-bg: transparent;\n    --bs-accordion-active-bg: transparent;\n}\n\n.accordion-button:not(.collapsed)::after {\n    --bs-accordion-btn-bg: transparent;\n    --bs-accordion-active-bg: transparent;\n}\n\n.accordion-button:not(.collapsed) {\n    --bs-accordion-active-bg: transparent;\n    /* border-top: 1px solid #B86BEB; */\n}\n\n.accordion-button {\n    /* font-size: 20px !important; */\n    --bs-accordion-btn-bg: transparent;\n    --bs-accordion-active-bg: transparent;\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 400;\n}\n\n.accordion-button.collapsed {\n    --bs-accordion-btn-bg: transparent;\n    --bs-accordion-active-bg: transparent;\n    /* font-size: 20px !important; */\n    font-family: \"Roboto\", sans-serif;\n    /* font-weight: 500; */\n    /* border-top: 1px solid #B86BEB; */\n    --bs-accordion-btn-color: #F9F9F9;\n}\n\n.accordion-item:first-of-type {\n    /* border-top: none; */\n}\n\n/* .first-item.accordion-button.collapsed {\n    border: none;\n} */\n\n\n.button.accordion-button.collapsed {\n    --bs-accordion-btn-bg: transparent;\n    --bs-accordion-active-bg: transparent;\n    /* font-size: 20px; */\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 500;\n    --bs-accordion-btn-color: #F9F9F9;\n}\n\n.accordion-header {\n    font-size: 20px;\n    font-family: \"Roboto\", sans-serif;\n    /* font-weight: 500; */\n    color: #F9F9F9;\n}\n\n.accordion-button::after {\n    --bs-accordion-btn-icon: url('./Images/plusiconv2.svg');\n\n    --bs-border-color: none;\n}\n\n.accordion-button:not(.collapsed)::after {\n    --bs-accordion-active-bg: transparent;\n    --bs-accordion-bg: transparent;\n    --bs-accordion-btn-active-icon: url('./Images/minusiconv3.svg');\n    --bs-accordion-btn-icon-transform: url('./Images/plusiconv2.svg');\n}\n\n/* .accordion-button:not(.collapsed)::after {\n    --bs-accordion-active-bg: transparent;\n    --bs-accordion-bg: transparent;\n    --bs-accordion-btn-active-icon: url(http://localhost:3000/static/media/minusicon.6d2fe56….svg);\n    --bs-accordion-btn-icon-transform: url(http://localhost:3000/static/media/plusicon.4c797a6….svg);\n} */\n\n.accordion-button:focus {\n    --bs-accordion-btn-focus-box-shadow: none;\n}\n\n\n\n.accordianimage {\n    /* width: 561px;\n    height: 437px; */\n    /* width: 35vw;\n    height: 60vh; */\n    /* top: 5px;\n    gap: 0px;\n    opacity: 0px; */\n\n}\n\n.accordiancontent {\n    /* width: 1251px; */\n    height: 100%;\n    /* margin-left: 94px; */\n    /* justify-content: center; */\n\n}\n\n.accordion {\n    --bs-border-color: none;\n    --bs-primary-text-emphasis: #EEEEF0;\n}\n\n@media(min-width: 200px) and (max-width: 345px) {\n    .accordion {\n        width: 100%;\n        margin-top: 15px;\n    }\n\n    .accordiancontent {\n        justify-content: center;\n        align-items: center;\n    }\n\n    .content-services {\n        font-size: 30px;\n    }\n\n    .sub-header {\n        font-size: 12px;\n        line-height: 20px;\n    }\n\n    .center-button {\n        height: 35px;\n        width: 160px;\n    }\n\n    .buttoncontainer {\n        margin-top: 5rem;\n    }\n\n    .imageoverlay {\n        height: 30%;\n        margin: 10px 20px 10px 3px;\n        border-radius: 10px;\n    }\n\n    .button-center.btn.btn-primary {\n        font-size: 12px;\n    }\n\n    .footer-msg {\n        font-size: 13px;\n        line-height: 25px;\n    }\n\n    .cloudofferinglayout {\n        /* height: 150vh */\n    }\n\n    .BigDataOfferings {\n        gap: 10px;\n    }\n\n    .rowgap {\n        gap: 10px;\n    }\n\n    .discover-button {\n        width: 100%;\n        height: 100%;\n        padding: 10px 2px;\n    }\n\n    .discover-icon {\n        width: 10px;\n    }\n\n    .discover-text {\n        margin-top: 5px;\n        font-size: 7px;\n    }\n\n    .font-caption {\n        font-size: 8px;\n        /* letter-spacing: 0px; */\n    }\n}\n\n@media(min-width: 345px) and (max-width: 567px) {\n    .accordion {\n        width: 100%;\n        margin-top: 15px;\n    }\n\n    .accordiancontent {\n        justify-content: center;\n        align-items: center;\n    }\n\n    .content-services {\n        font-size: 30px;\n    }\n\n    .sub-header {\n        font-size: 12px;\n        line-height: 20px;\n    }\n\n    .center-button {\n        height: 35px;\n        width: 160px;\n    }\n\n    .buttoncontainer {\n        margin-top: 5rem;\n    }\n\n    .imageoverlay {\n        height: 32%;\n        margin: 10px 20px 10px 3px;\n        border-radius: 10px;\n    }\n\n    .button-center.btn.btn-primary {\n        font-size: 12px;\n    }\n\n    .footer-msg {\n        font-size: 13px;\n        line-height: 25px;\n    }\n\n    .cloudofferinglayout {\n        /* height: 150vh */\n    }\n\n    .BigDataOfferings {\n        gap: 10px;\n    }\n\n    .rowgap {\n        gap: 10px;\n    }\n\n    .discover-button {\n        width: 100%;\n        height: 100%;\n        padding: 15px 5px;\n    }\n\n    .discover-icon {\n        width: 15px;\n    }\n\n    .discover-text {\n        margin-top: 5px;\n        font-size: 10px;\n    }\n\n    .font-caption {\n        font-size: 10px;\n        /* letter-spacing: 0px; */\n    }\n\n    .center-button-banner {\n        height: 30px;\n        width: fit-content;\n        padding: 0px 20px;\n    }\n\n    .button-center-banner.btn.btn-primary {\n        font-size: 10px;\n    }\n}\n\n@media(min-width: 567px) {\n    .accordion {\n        width: 40vw;\n    }\n\n    .accordiancontent {\n        justify-content: center;\n    }\n\n    .content-services {\n        font-size: 50px;\n    }\n\n    .sub-header {\n        font-size: 18px;\n        line-height: 35px;\n    }\n\n    .center-button {\n        height: 61px;\n        width: 292.24px;\n    }\n\n    .center-button-banner {\n        height: 50px;\n        width: 245px;\n    }\n\n    .center-button-accordian {\n        width: fit-content;\n        height: fit-content;\n    }\n\n    .buttoncontainer {\n        margin-top: 7rem;\n    }\n\n    .imageoverlay {\n        height: 24%;\n        margin: 0px 20px 10px 10px;\n        border-radius: 20px;\n    }\n\n    .button-center.btn.btn-primary {\n        font-size: 19.14px;\n    }\n\n    .footer-msg {\n        font-size: 16px;\n        line-height: 40px;\n    }\n\n    .cloudofferinglayout {\n        /* height: 50vh; */\n    }\n\n    .BigDataOfferings {\n        gap: 30px;\n    }\n\n    .rowgap {\n        gap: 0px\n    }\n\n    .discover-button {\n        width: 100px;\n        height: 100px;\n        padding: 15px 10px;\n    }\n\n    .discover-icon {\n        width: 20px;\n    }\n\n    .discover-text {\n        margin-top: 5px;\n        font-size: 14px;\n    }\n\n    .font-caption {\n        font-size: 15px;\n        /* letter-spacing: -1.67px; */\n    }\n}\n\n.button-center-banner.btn.btn-primary,\n.button-center.btn.btn-primary {\n    box-shadow: 0px 10px 51.95px 0px #3A1E4B;\n    --bs-btn-active-border-color: #B86BEB;\n    --bs-btn-border-color: #B86BEB;\n    --bs-btn-border-width: 1.2px;\n    /* --bs-btn-bg: transparent; */\n    --bs-btn-bg: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%);\n    /* font-size: 19.14px; */\n    border: 1.2px solid #B86BEB;\n    border-radius: 50px;\n    /* background: rgba(34, 29, 65, 0.5); */\n    /* background: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%); */\n    background:\n        rgba(58, 30, 75, 0.5);\n    /* justify-content: center;\n    align-content: center; */\n\n}\n\n\n.button-center {\n    /* display: flex;\n    justify-content: center;\n    align-items: center; */\n    /* margin: 0; */\n    position: absolute;\n    /* top: 80%;\n    left: 50%; */\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    justify-content: center;\n    align-content: center;\n}\n\n\n.buttoncontainer {\n    /* height: 100%; */\n    /* position: relative; */\n    justify-content: center;\n    align-content: center;\n    bottom: 10px;\n}\n\n.buttoncontainer-extra {\n    /* height: 100%; */\n    position: relative;\n    bottom: 6vh;\n    padding-bottom: 9vh;\n}\n\n/* \n.center-button {\n    height: 61px;\n    width: 292.24px;\n    border-radius: 50%;\n} */\n\n\n.overlaycontainer {\n    position: relative;\n    /* width: 50%; */\n}\n\n.image {\n    display: block;\n    width: 100%;\n    height: auto;\n}\n\n.imageoverlay {\n    position: absolute;\n    bottom: 0;\n    top: 25;\n    /* background-color: #008CBA; */\n    overflow: hidden;\n    /* margin: 0px 20px 10px 10px; */\n    width: 95%;\n    /* height: 25%; */\n    transition: .5s ease;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    /* border-radius: 20px; */\n    background: linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),\n        linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),\n        linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8));\n    opacity: 85%;\n}\n\n.overlaycontainer:hover .imageoverlay {\n    border-radius: 10%;\n    height: 55%;\n}\n\n.overlaycontainer:hover .overlaytext {\n    top: 50%;\n}\n\n/* @media (min-width: 576px) {\n    .container, .container-sm {\n        max-width: 690px;\n    }\n} */\n\n@media (min-width: 200px) {\n    .overlaytext {\n        /* padding:5px; */\n        font-weight: 400;\n        font-size: 10px;\n        /* width: 25vw;\n        height: 13vh; */\n        width: 100%;\n        height: 100%;\n        overflow-y: scroll;\n    }\n\n    .overlaycontainer:hover .paragraph {\n        font-weight: 250;\n        font-size: 7px;\n        /* letter-spacing: 1px; */\n    }\n\n    .accordianimage {\n        width: 35vw;\n        height: auto;\n        top: 5px;\n        gap: 0px;\n        justify-content: center;\n    }\n\n    .accordion-button,\n    .accordion-button.collapsed {\n        font-size: 15px !important;\n    }\n\n    .accordion-body {\n        font-size: 13px;\n        --bs-accordion-body-padding-y: 0.5rem;\n        --bs-accordion-body-padding-x: 1.25rem;\n    }\n\n    .container,\n    .container-sm {\n        min-width: 100%;\n    }\n}\n\n@media (min-width: 300px) {\n    .overlaytext {\n        /* padding:5px; */\n        font-weight: 400;\n        font-size: 6px;\n        /* width: 25vw;\n        height: 13vh; */\n        width: 100%;\n        height: 100%;\n        overflow-y: scroll;\n        padding: 3px 10px !important;\n    }\n\n    .overlaycontainer:hover .paragraph {\n        font-weight: 300;\n        font-size: 5px;\n        /* letter-spacing: 1px; */\n    }\n\n    .accordianimage {\n        width: 49vw;\n        height: auto;\n        /* top: 5px; */\n        gap: 0px;\n        /* opacity: 1; */\n        justify-content: center;\n        align-items: center;\n    }\n\n    .accordion-button,\n    .accordion-button.collapsed {\n        font-size: 17px !important;\n        --bs-accordion-btn-padding-y: 0.5rem;\n    }\n\n    .accordion-body {\n        font-size: 13px;\n        --bs-accordion-body-padding-y: 0.5rem;\n        --bs-accordion-body-padding-x: 1rem;\n    }\n\n    .container,\n    .container-sm {\n        min-width: 100%;\n    }\n}\n\n@media (min-width: 400px) {\n    .overlaytext {\n        /* padding:5px; */\n        font-weight: 400;\n        font-size: 10px;\n        /* width: 25vw;\n        height: 13vh; */\n        width: 100%;\n        height: 100%;\n        overflow-y: scroll;\n    }\n\n    .overlaycontainer:hover .paragraph {\n        font-weight: 250;\n        font-size: 9px;\n        /* letter-spacing: 1px; */\n    }\n\n    .accordianimage {\n        width: 49vw;\n        height: auto;\n        /* top: 5px; */\n        gap: 0px;\n        /* opacity: 1; */\n        justify-content: center;\n        align-items: center;\n    }\n\n    .accordion-button,\n    .accordion-button.collapsed {\n        font-size: 15px !important;\n        --bs-accordion-btn-padding-y: 1rem;\n    }\n\n    .accordion-body {\n        font-size: 13px;\n        --bs-accordion-body-padding-y: 0rem;\n        --bs-accordion-body-padding-x: 1rem;\n    }\n\n    .container,\n    .container-sm {\n        min-width: 100%;\n    }\n}\n\n@media (min-width: 576px) {\n    .overlaytext {\n        /* padding:5px; */\n        font-weight: 400;\n        font-size: 10px;\n        /* width: 25vw;\n        height: 13vh; */\n        width: 100%;\n        height: 100%;\n        overflow-y: scroll;\n    }\n\n    .overlaycontainer:hover .paragraph {\n        font-weight: 250;\n        font-size: 9px;\n        /* letter-spacing: 1px; */\n    }\n\n    .accordianimage {\n        width: 45vw;\n        height: auto;\n        /* top: 5px; */\n        gap: 0px;\n        /* opacity: 1; */\n        justify-content: center;\n        align-items: center;\n    }\n\n    .accordion-button,\n    .accordion-button.collapsed {\n        font-size: 17px !important;\n        --bs-accordion-btn-padding-y: 1rem;\n    }\n\n    .accordion-body {\n        font-size: 13px;\n        --bs-accordion-body-padding-y: 0.5rem;\n        --bs-accordion-body-padding-x: 1.25rem;\n    }\n\n    .container,\n    .container-sm {\n        min-width: 100%;\n    }\n}\n\n@media (min-width: 768px) {\n    .overlaytext {\n        padding: 5px;\n        font-weight: 400;\n        font-size: 15px;\n        /* width: 25vw;\n        height: 20vh; */\n        width: 100%;\n        height: 100%;\n        overflow-y: scroll;\n    }\n\n    .overlaycontainer:hover .paragraph {\n        font-weight: 250;\n        font-size: 12px;\n        /* letter-spacing: -1px; */\n    }\n\n    .accordianimage {\n        width: 40vw;\n        height: auto;\n        /* top: 5px; */\n        gap: 0px;\n        /* opacity: 1; */\n        justify-content: center;\n    }\n\n    .accordion-button,\n    .accordion-button.collapsed {\n        font-size: 18px !important;\n        --bs-accordion-btn-padding-y: 1rem;\n    }\n\n    .accordion-body {\n        font-size: 14px;\n        --bs-accordion-body-padding-y: 0.5rem;\n        --bs-accordion-body-padding-x: 1.25rem;\n    }\n\n    .container,\n    .container-sm {\n        min-width: 100%;\n    }\n}\n\n@media (min-width: 992px) {\n    .overlaytext {\n        padding: 5px;\n        font-weight: 600;\n        font-size: 18px;\n        /* width: 25vw;\n        height: 24vh; */\n        width: 100%;\n        height: 100%;\n        overflow-y: scroll;\n    }\n\n    .overlaycontainer:hover .paragraph {\n        font-weight: 250;\n        font-size: 12px;\n        /* letter-spacing: -1px; */\n    }\n\n    .accordianimage {\n        width: 40vw;\n        height: auto;\n        /* top: 5px; */\n        gap: 0px;\n        /* opacity: 1; */\n    }\n\n    .accordion-button,\n    .accordion-button.collapsed {\n        font-size: 20px !important;\n        --bs-accordion-btn-padding-y: 1rem;\n    }\n\n    .accordion-body {\n        font-size: 16px;\n        --bs-accordion-body-padding-y: 1.50rem;\n        --bs-accordion-body-padding-x: 1.25rem\n    }\n}\n\n/* , min-width: 1200px, min-width: 576px,min-width: 768px */\n@media (min-width: 1200px) {\n    .overlaytext {\n        position: relative;\n        font-weight: 600;\n        font-size: 18px;\n        /* width: 23vw;\n        height: 30vh; */\n        width: 100%;\n        height: 100%;\n        overflow-y: scroll;\n        margin-top: 3%;\n    }\n\n    .overlaycontainer:hover .paragraph {\n        font-weight: 600;\n        font-size: 14px;\n        /* letter-spacing: -1.34px; */\n    }\n\n    .accordianimage {\n        width: 35vw;\n        height: auto;\n        top: 5px;\n        gap: 0px;\n        /* opacity: 1; */\n    }\n\n    .accordion-button,\n    .accordion-button.collapsed {\n        font-size: 20px !important;\n    }\n\n    .accordion-body {\n        font-size: 16px;\n        --bs-accordion-body-padding-y: 1.50rem;\n        --bs-accordion-body-padding-x: 1.25rem\n    }\n\n    /* .overlaytext1 {\n        justify-content: center;\n        align-items: center;\n    } */\n}\n\n@media (min-width: 1400px) {\n    .overlaytext {\n        position: relative;\n        font-weight: 600;\n        font-size: 20px;\n        /* width: 23vw; */\n        /* height: 30vh; */\n        width: 100%;\n        height: 100%;\n        overflow-y: scroll;\n        /* margin-top: 3%; */\n    }\n\n    .overlaycontainer:hover .paragraph {\n        font-weight: 600;\n        font-size: 14px;\n    }\n\n    .accordianimage {\n        width: 100%;\n        height: 100%;\n        top: 5px;\n        gap: 0px;\n        /* opacity: 1; */\n\n    }\n\n    .accordion-button {\n        font-size: 20px !important;\n        --bs-accordion-btn-padding-y: 0.5rem;\n    }\n\n    .accordion-body {\n        font-size: 16px;\n        --bs-accordion-body-padding-y: 1rem;\n        --bs-accordion-body-padding-x: 1.25rem\n    }\n\n    /* .overlaytext1 {\n        justify-content: center;\n        align-items: center;\n    } */\n}\n\n.overlaytext {\n    color: rgba(255, 255, 255, 1);\n    /* font-weight: 700;\n    font-size: 19px; */\n    font-family: \"Roboto\", sans-serif;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    text-align: left;\n    /* width: 20vw; */\n    /* height: 25vh; */\n    gap: 0px;\n    padding: 0px 10px;\n    /* border-radius: 10%; */\n\n    /* Big Data Infrastructure & Management: Building the Foundation for Insights */\n\n    font-style: normal;\n\n    color: #FFFFFF;\n\n\n}\n\n\n.paragraph {\n    color: rgba(255, 255, 255, 0.7);\n    /* font-weight: 600;\n    font-size: 14px; */\n    /* letter-spacing: -1.34px; */\n    font-size: 0px;\n    font-family: \"Roboto\", sans-serif;\n    display: block;\n}\n\n\n\n\n.footer-msg {\n    color: rgba(255, 255, 255, 1);\n    /* font-size: 16px; */\n    font-weight: 400;\n    display: block;\n    text-align: center;\n    /* line-height: 27.3px; */\n}\n\n.footer-msg-logo {\n    font-family: \"Orbitron\", sans-serif;\n    color: #9e5ed2;\n    /* font-size: 16px; */\n    font-weight: 500;\n    display: block;\n    text-align: left;\n    /* line-height: 27.3px; */\n}\n\n.footer-submsg {\n    font-family: \"Roboto\";\n    color: rgba(255, 255, 255, 1);\n    font-size: 15px;\n    font-weight: 400;\n    z-index: 10;\n    cursor: pointer;\n}\n\n.contact-logo {\n    gap: 5%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n\n.Footercontact {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-left: 10px;\n}\n\n.div-center {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.div-right {\n    display: flex;\n    justify-content: right;\n    align-items: center;\n}\n\n.div-left {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.navbar-toggler {\n    --bs-navbar-toggler-border-color: white;\n    --bs-navbar-color: white;\n}\n\n.span.navbar-toggler-icon {\n    /* --bs-navbar-toggler-icon-bg:  url(data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e); */\n    --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba(255, 255, 255, 0.75)%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e\");\n\n}\n\n.btn {\n    --bs-btn-font-family: \"Roboto\", sans-serif;\n    ;\n    --bs-btn-font-size: 17px;\n    --bs-btn-font-weight: 700;\n}\n\n.backgroundcolor {\n    background: rgba(6, 0, 12, 1);\n    width: 100%;\n    height: auto;\n}\n\n\n\n\n/* Rectangle 1544 */\n\n/* position: absolute;\nwidth: 707.17px;\nheight: 436.14px;\nleft: -102.37px;\ntop: 210.5px;\n\nbackground: rgba(0, 0, 0, 0.8);\nfilter: blur(55.0329px); */\n\n.overlay-genai-container {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 30%;\n    /* Adjust this to control how much of the bottom is covered */\n    /* background: rgba(0, 0, 0, 0.8); */\n    background-image: radial-gradient(circle, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.6));\n    filter: blur(65.0329px);\n\n}\n\n\n.dropdown-toggle::after {\n    display: none !important;\n}\n\n\n\n\n.dropdown-menu {\n    --bs-body-bg: rgba(12, 23, 36, 1);\n    --bs-border-radius: 24.16px;\n    --bs-border-color-translucent: rgba(28, 31, 34, 1);\n    box-shadow: 0px 36.24px 84.57px 0px rgba(167, 174, 186, 0.16);\n    --bs-border-width: 1.51px;\n    color: rgba(255, 255, 255, 1);\n    --bs-dropdown-padding-y: 1rem !important;\n    --bs-dropdown-padding-x: 1rem !important;\n    /* display: flex !important;\nflex-direction: column !important; */\n}\n\n.dropdown-item {\n    --bs-dropdown-link-color: rgba(255, 255, 255, 1);\n    font-size: 16px;\n    font-weight: 700;\n    font-family: \"Roboto\", sans-serif;\n    --bs-dropdown-item-padding-y: 0.50rem;\n    --bs-dropdown-item-padding-x: 1rem;\n    /* background: linear-gradient(270deg, rgba(23, 23, 23, 0.5) 0.26%, rgba(125, 24, 188, 0.5) 40.8%, rgba(23, 23, 23, 0.5) 102.25%); */\n    margin: 10px 10px;\n    gap: 15px;\n    display: inline-flex;\n}\n\n.dropdown-item:focus,\n.dropdown-item:hover {\n    --bs-dropdown-link-hover-color: rgba(255, 255, 255, 1);\n    --bs-dropdown-link-hover-bg: none;\n    background: linear-gradient(270deg, rgba(23, 23, 23, 0.5) 0.26%, rgba(125, 24, 188, 0.5) 40.8%, rgba(23, 23, 23, 0.5) 102.25%) !important;\n}\n\n\n/* .App {\n    font-family: sans-serif;\n    text-align: center;\n  } */\n\n.cardContainer {\n    background-color: blue;\n    /*margin: 20px;*/\n    display: flex;\n    flex-direction: column;\n    flex-grow: 2;\n    align-items: center;\n    box-shadow: 5px 4px 5px rgba(0, 0, 0, 0.4);\n}\n\n.titleContainer {\n    background-color: white;\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    margin-top: 5px;\n}\n\n#title {\n    flex-grow: 3;\n    position: relative;\n}\n\n#rating {\n    width: 40%;\n    background-color: orange;\n    flex-direction: row;\n}\n\n.cardImgContainer {\n    background-color: green;\n}\n\n.cardImgContainer img {\n    object-fit: fill;\n}\n\n.cardTextContainer {\n    background-color: red;\n}\n\n.buttontransform {\n    transition: transform 0.3s ease-in-out;\n}\n\n.buttontransform:hover {\n    transform: rotate(-40deg);\n\n}\n\n.circlestyle {\n    align-items: center;\n    justify-content: center;\n    width: 35px;\n    /* Adjust size as needed */\n    height: 35px;\n    border-radius: 50%;\n    /* Ensure the border is also circular */\n    /* background: rgba(34, 29, 65, 0.5); */\n    border: 1.45px solid #B86BEB;\n    /* border-image-source: linear-gradient(180deg, #B86BEB 0%, #7D18BC 100%); */\n    border-image-slice: 10;\n    display: inline-flex;\n}\n\n.centericon {\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n}\n\n.dropdown-text {\n    line-height: 32px; \n    margin: 0px 0px 5px 5px;\n  }\n\n\n .flexrow-header {\n    display: flex;\n    flex-direction: row;\n}\n@media(min-width: 345px) and (max-width: 567px) {\n    .flexrow-header {\n        display: flex;\n        flex-direction: column !important;\n    }\n}\n\n.quadchainlogo {\n    margin-left: 2%;\n    height: 18vh;\n    width: 15vw;\n    position: absolute;\n    left: 0;\n  }\n  \n  /* Tablet (width between 600px and 1024px) */\n@media (max-width: 1024px) {\n    .quadchainlogo {\n      width: 25vw;\n      height: 12vh;\n    }\n  }\n  \n  /* Mobile (width below 600px) */\n  @media (max-width: 600px) {\n    .quadchainlogo {\n      width: 40vw;\n      height: 10vh;\n      margin-left: 5%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
